export const getTestVariant = (userId: number, numberOfVariants = 2) =>
  userId % numberOfVariants;
